import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="container navbar-container">
        {/* Use Link for logo too */}
        <Link to="/" className="navbar-logo">
          <img src="/assets/tronixAI Logo-monogram.png" alt="tronixAI Logo" />
        </Link>
        <ul className="nav-menu">
          <li><Link to="/" className="nav-link">Home</Link></li>
          <li>
  <Link to="/services" className="nav-link">Services</Link>
</li>
          {/* Update these to links for future pages */}
          <li><Link to="/solutions" className="nav-link">Solutions</Link></li>
          <li><Link to="/about" className="nav-link">About Us</Link></li>
          <li><Link to="/contact" className="nav-link">Contact</Link></li>
        </ul>
        {/* CHANGED: Button is now a Link to /contact */}
        <Link to="/contact" className="btn btn-gradient">Get a Quote</Link>
      </div>
    </nav>
  );
};

export default Navbar;